export const debounce = (_func: (...args: any[]) => void, _delay: number) => {
    let timeout: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => _func(...args), _delay);
    };
};
